import {eshiminInvoke, eshiminOpenService} from "./eshiminUtils";
import axios from "axios";
import wx from 'weixin-js-sdk'

export function jumpHandle(pageType, reference, url) {
  let eshiminURL = 'https://zwdtuser.sh.gov.cn/uc/oauth2.0/smyLoginEntry.do?redirect_uri='
  if (pageType === 'native') {
    if (reference === 'mini_wechat') {
      try {
        let path = url
        wx.miniProgram.getEnv(() => {
          wx.miniProgram.navigateTo({
            url: path, // 小程序跳转路径
            success: function () {
              console.log('success')
            },
            fail: function () {
              alert('跳转回微信小程序的页面fail')
            }
          })
        })
      } catch (e) {
        alert('调用微信小程序API错误')
      }
    } else if (reference === 'mini_alipay') {
      try {
        // eslint-disable-next-line no-undef
        my.navigateTo({
          url: url,
          success: function () {
            console.log('succeed in calling alipay')
          },
          fail: function () {
            alert('跳转回支付宝小程序的页面fail')
          }
        })
      } catch (e) {
        alert(e)
        alert('调用支付宝小程序API错误')
      }
    } else {
      console.log('esmin')
      eshiminOpenService(url)
    }
  } else {
    if (reference === 'mini_wechat' || reference === 'mini_alipay') {
      axios.post('/forwarder/login/fetchAccessToken').then(res => {
        if (res.status === '200') {
          let token = res.access_token
          if (url.indexOf('?') !== -1) {
            window.location.href = url + '&access_token=' + token
          } else {
            window.location.href = url + '?access_token=' + token
          }
        }
      })
    } else {
      window.location.href = eshiminURL + url
    }
  }
}
